import { doc, getDoc, serverTimestamp, setDoc } from 'firebase/firestore';
import { db } from './firebase';
import { migrateSave } from './save';
import type { SaveData } from '../types';

const playerRef = (uid: string) => doc(db, 'players', uid);

export async function loadCloudSave(uid: string): Promise<SaveData | null> {
  const snapshot = await getDoc(playerRef(uid));
  if (!snapshot.exists()) return null;
  return migrateSave(snapshot.data().save);
}

export async function storeCloudSave(uid: string, save: SaveData): Promise<void> {
  await setDoc(playerRef(uid), { save, updatedAt: serverTimestamp() }, { merge: true });
}
